import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  const handleCustomize = () => {
    localStorage.setItem('cookieConsent', 'customized');
    setShowConsent(false);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Utilizzo dei Cookie</h3>
          <p>
            Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito, 
            per analizzare il traffico e personalizzare i contenuti. I cookie ci aiutano 
            a comprendere come utilizzi il nostro sito web.
          </p>
          <p>
            Per ulteriori informazioni, consulta la nostra{' '}
            <Link to="/privacy-policy">Politica sulla Privacy</Link>.
          </p>
        </div>
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="cookie-btn cookie-accept">
            Accetta Tutti
          </button>
          <button onClick={handleDecline} className="cookie-btn cookie-decline">
            Rifiuta
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;